import CharacterInfo from '@assets/icons/character-info.svg'
import { Icon } from './Icon'

export const CharacterInfoIcon = Icon(CharacterInfo)
